export default "__VITE_ASSET__fdQP2jW2__"